import { types as lifecycleTypes } from 'common/modules/lifecycle/actions'
import { types as arbiterTypes } from 'common/modules/arbiter/actions'

let picoReady = false
let mutatorsReady = false

const isReady = () => picoReady && mutatorsReady

export default {
    [arbiterTypes.PICO_READY]: [
        {
            event: 'pico.ready',
            data() {
                picoReady = true
                return isReady() && {}
            },
        },
    ],
    [lifecycleTypes.MUTATORS_READY]: [
        {
            event: 'pico.ready',
            data() {
                mutatorsReady = true
                return isReady() && {}
            },
        },
    ],
}
